import { convertLength, normalizeDegreeOrientation, radiansToDegrees } from "@buildwithflux/shared";
import SparkMD5 from "spark-md5";
import { Clipper } from "../../../clipper";
import { vec2 } from "../../../common";
import { CurveDivisions } from "../../../fills/CopperFillHandler";
import { approxFittingPolygon } from "../../../pcb/primitive_store/math";
export class AliffHelpers {
    static origin = { x: 0, y: 0 };
    static toNm(meters) {
        return Math.round(Number(convertLength(meters ?? 0, "m", "nm").toFixed(14)));
    }
    static getPoint(position, offset = this.origin) {
        if (Array.isArray(position)) {
            position = { x: position[0], y: position[1] };
        }
        const { x, y } = vec2.sub(position, offset);
        return [this.toNm(x), this.toNm(y)];
    }
    static getRotation(radians) {
        return normalizeDegreeOrientation(Math.round(radiansToDegrees(radians)));
    }
    static expandShape(shapeFromShapeStore, expandBy) {
        const polygon = approxFittingPolygon(shapeFromShapeStore, CurveDivisions);
        if (expandBy === 0) {
            return polygon;
        }
        const clipperShape = Clipper.shape([polygon]);
        const expandedClipperShape = clipperShape.offset(expandBy);
        const [expandedPolygon = []] = expandedClipperShape.toPolygons();
        return expandedPolygon;
    }
    static hash(hashData) {
        const stringifiedHashData = hashData.map((data) => JSON.stringify(data));
        return SparkMD5.hash(stringifiedHashData.join("|"));
    }
    /**
     * Returns a unique name for a node
     */
    static getUniqueNodeName(node, shouldSanitize) {
        const hash = this.hash([node.uid]);
        const uniqueName = `${node.name ?? node.type}_${hash}`;
        if (shouldSanitize) {
            return uniqueName.replace(/-/g, "–");
        }
        return uniqueName;
    }
}
/**
 * Returns the file extension for the Aliff file export based on the environment.
 *
 * Terser plugin will replace the return value with the actual string during the build process so we don't
 * expose "deeppcb" to production build.
 */
export function getAliffFileExportExtension(environment) {
    return environment === "local" || environment === "preview" ? "deeppcb" : "json";
}
//# sourceMappingURL=helpers.js.map